import styled from "styled-components";
import { getDirection } from "../../../../themes/common";
import { theme } from "../theme/toyotaTheme";
import { legalStyle } from "../globals/Type";

export const EcoWrapper = styled.div`
    margin: ${theme.space[2]}px 0;
`;

export const EcoImage = styled.img`
    max-width: 100%;
    margin: ${theme.space[2]}px 0;
`;

export const EcoImageDescription = styled.div`
    color: ${theme.colors.grey4};
`;

export const EcoDisclaimer = styled.div`
    color: ${theme.colors.grey4};
    ${legalStyle};
`;

export const EcoBadge = styled.div<{ backgroundColor: string }>`
    display: flex;
    position: relative;
    top: -2px;
    align-items: center;
    justify-content: center;
    min-width: 26px;
    height: 22px;
    margin: 0 8px 0 13px;
    font-size: 1.3rem;
    line-height: 1.5;
    text-align: center;
    color: ${theme.colors.primaryWhite};
    background-color: ${({ backgroundColor }) => backgroundColor};
    vertical-align: baseline;
    z-index: 1;
    &::before {
        position: absolute;
        top: 3px;
        ${getDirection("left")}: -8px;
        width: 16px;
        height: 16px;
        content: "";
        background-color: inherit;
        border-radius: 2px;
        transform: rotate(-45deg);
        z-index: -1;
    }
`;
